<ion-content>

  <ion-card style="position:absolute; bottom: 0; background: #F8F9F9;" class="ion-no-margin">
    <div class="modal-head">
      <div class="ion-text-center close-button">
        <ion-button class="ion-no-padding" expand="block" color="dark" fill="clear" (click)="dismissModal()">Close
        </ion-button>
      </div>
      <p class="interest-title">Your Interests</p>
      <div class="ion-text-center close-button">
        <ion-button class="ion-no-padding" expand="block" color="dark" fill="clear" (click)="sendInterests()">Update
        </ion-button>
      </div>
    </div>
    <div class="interests-modal">

      <div class="small-message-text">
        Select at least 3 categories to see what products are trending.
      </div>
      <div class="buttons">
        <ion-button *ngFor="let category of categories$ | async" size="small"
          [color]="highlightInterest(category.name) ? 'primary' : 'button-outline'" [fill]="highlightInterest(category.name) ? 'solid'
          : 'outline'" shape="round" class="cat-button button-on" (click)="createInterests(category.name)"
          (click)="category.selected = !category.selected">
          {{category.name}}
        </ion-button>
      </div>

    </div>
  </ion-card>

</ion-content>